export const rtlLangs: string[] = ['ar'];
